import { h } from 'preact';
import PropTypes from 'prop-types';
import { SocialShare } from '@sky-uk/sky-social-share';

export const SocialShareComponent = ({ htmlProps }) => {
  return <SocialShare {...htmlProps} />;
};

SocialShareComponent.propTypes = {
  htmlProps: PropTypes.shape({
    socials: PropTypes.array,
    site: PropTypes.string,
    onMount: PropTypes.func,
    darkMode: PropTypes.bool,
    showLabel: PropTypes.bool,
    isAnchoredRight: PropTypes.bool,
    isIconBordered: PropTypes.bool,
  }).isRequired,
};
